import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _25df5dbd = () => interopDefault(import('../pages/embed/_project/index.vue' /* webpackChunkName: "pages/embed/_project/index" */))
const _0dba2cfd = () => interopDefault(import('../pages/project/_project/index.vue' /* webpackChunkName: "pages/project/_project/index" */))
const _2eae85d6 = () => interopDefault(import('../pages/embed/_project/space/_space.vue' /* webpackChunkName: "pages/embed/_project/space/_space" */))
const _632245d5 = () => interopDefault(import('../pages/project/_project/space/_space.vue' /* webpackChunkName: "pages/project/_project/space/_space" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/embed/:project",
    component: _25df5dbd,
    name: "embed-project"
  }, {
    path: "/project/:project",
    component: _0dba2cfd,
    name: "project-project"
  }, {
    path: "/embed/:project?/space/:space?",
    component: _2eae85d6,
    name: "embed-project-space-space"
  }, {
    path: "/project/:project?/space/:space?",
    component: _632245d5,
    name: "project-project-space-space"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
